module.exports = __webpack_public_path__ + "static/media/bro.652a72f2.png";